import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b6b457ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b6b457ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b457ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/panzhijing/蛋卷科技/danjuan-admin/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6b457ba')) {
      api.createRecord('b6b457ba', component.options)
    } else {
      api.reload('b6b457ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b6b457ba&scoped=true", function () {
      api.rerender('b6b457ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/callDrawerPage/callNotHandled/defaultItem/index.vue"
export default component.exports